<template>
    <div v-if="isBailleurSocial && post">
        <el-tag :size="size" v-if="post.typeObjet >= 3000 && post.typeObjet < 4000" type="warning">Prog. neuf</el-tag>
        <el-tag :size="size" v-else-if="post.typeObjet >= 4000 && post.typeObjet < 5000" type="danger">Lot neuf</el-tag>
        <el-tag :size="size" v-else-if="post.annonceParente" type="danger">Lot neuf</el-tag>
        <el-tag :size="size" v-else-if="post.typeOffre && (post.typeOffre === 'G')" type="warning">Vente neuf</el-tag>
        <el-tag :size="size" v-else type="success">Immo ancien</el-tag>
    </div>
    <div v-else-if="isBailleurSocial && typeObjet">
        <el-tag :size="size" v-if="typeObjet >= 3000 && typeObjet < 4000" type="warning">Prog. neuf</el-tag>
        <el-tag :size="size" v-else-if="typeObjet >= 4000 && typeObjet < 5000" type="danger">Lot neuf</el-tag>
        <el-tag :size="size" v-else-if="annonceParente" type="danger">Lot neuf</el-tag>
        <el-tag :size="size" v-else-if="typeOffre && (typeOffre === 'G')" type="warning">Vente neuf</el-tag>
        <el-tag :size="size" v-else type="success">Immo ancien</el-tag>
    </div>
</template>

<script>

export default {
  name: 'TagsPosts',
  props: ['post', 'size', 'typeObjet', 'typeOffre', 'annonceParente'],
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    possedeInstagram () {
      return this.user.possedeInstagram
    }
  },
  async beforeMount () {
  }
}
</script>

<style>
    .el-tag.el-tag--warning {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #ffffff;
        border-radius: 15px;
    }

    .el-tag.el-tag--danger {
        background-color: #d24554;
        border-color: #d24554;
        color: #ffffff;
        border-radius: 15px;
    }

    .el-tag.el-tag--success {
        background-color: #25a78d;
        border-color: #25a78d;
        color: #ffffff;
        border-radius: 15px;
    }
</style>
